module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }, [_c('h1', {
    staticClass: "tochead"
  }, [_vm._v("CONTENTS")])]), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/006_Acknowledgements"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1tt"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1"
    }
  }, [_c('span', {
    staticClass: "toc1hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v(" History of the Census")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1#h3a1"
    }
  }, [_vm._v("What is a Census?")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1#h3a2"
    }
  }, [_vm._v("How and Why were the Nineteenth-Century Census Records Created?")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1#h3a3"
    }
  }, [_vm._v("The Historical Use of Censuses")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1#h3a4"
    }
  }, [_vm._v("Current Uses of Historical Censuses")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1#h3a5"
    }
  }, [_vm._v("Why Some People are not Found on Censuses")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1#h3a6"
    }
  }, [_vm._v("Records of People in Institutions and the Homeless")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1tt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])]), _vm._v(" Early Censuses")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2#h3b1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Surviving Pre-1841 Censuses")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2#h3b2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Local Censuses 1801–31 Online")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2#h3b3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Census Alternatives")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2#h3b4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Census Alternatives Online")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2#h3b5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colonial Censuses")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1tt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])]), _vm._v(" 1841: The First Modern Census")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#h3c1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Historical Context")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#h3c2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Details are Included?")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#h3c3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding Aids")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#h3c4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Online Resources")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#h3c5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free Resources")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#h3c6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problems")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#h3c7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Use the Census Effectively")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#h3c8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taking it Further")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#h3c9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unique Features of the Non-English Censuses")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3#h3c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-6"
    }
  }), _c('h2', {
    staticClass: "toc1tt"
  }, [_c('a', {
    attrs: {
      "id": "VPS-6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])]), _vm._v(" 1851: The Victorian Census")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#h3d1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Historical Context")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#h3d2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Details are Included?")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#h3d3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religious Census")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#h3d4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Education Census")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#h3d5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding Aids")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#h3d6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Online Resources")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#h3d7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free Resources")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#h3d8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problems")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#h3d9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Use the Census Effectively")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#h3d10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taking it Further")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#h3d11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unique Features of the Non-English Censuses")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4#h3d12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1tt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])]), _vm._v(" 1861: The First Separate Scottish Census")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_5#h3e1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Historical Context")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_5#h3e2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Details are Included?")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_5#h3e3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding Aids")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_5#h3e4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Online Resources")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_5#h3e5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free Resources")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_5#h3e6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problems")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_5#h3e7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Use the Census Effectively")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_5#h3e8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taking it Further")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_5#h3e9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unique Features of the Non-English Censuses")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_5#h3e10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1tt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")])]), _vm._v(" 1871: The Last Census Overseen by Graham and Farr")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_6#h3f1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Historical Context")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_6#h3f2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Details are Included?")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_6#h3f3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding Aids")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_6#h3f4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Online Resources")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_6#h3f5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free Resources")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_6#h3f6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problems")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_6#h3f7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Use the Census Effectively")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_6#h3f8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taking it Further")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_6#h3f9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unique Features of the Non-English Censuses")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_6#h3f10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1tt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")])]), _vm._v(" 1881: The First Census to be Used by Family Historians")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_7#h3g1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Historical Context")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_7#h3g2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Details are Included?")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-7"
    }
  }), _c('h3', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "id": "VPS-7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_7#h3g3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding Aids")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_7#h3g4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Online Resources")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_7#h3g5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free Resources")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_7#h3g6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problems")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_7#h3g7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Use the Census Effectively")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_7#h3g8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taking it Further")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_7#h3g9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unique Features of the Non-English Censuses")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_7#h3g10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1tt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8")])]), _vm._v(" 1891: The Introduction of Rooms and Employment Status to the Census")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_8#h3h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Historical Context")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_8#h3h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Details are Included?")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_8#h3h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding Aids")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_8#h3h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Online Resources")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_8#h3h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free Resources")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_8#h3h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problems")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_8#h3h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Use the Census Effectively")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_8#h3h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taking it Further")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_8#h3h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unique Features of the Non-English Censuses")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_8#h3h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1tt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9")])]), _vm._v(" 1901: The Centenary of Census-Taking in England, Scotland and Wales")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Chapter_9#h3i1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 1896 Quinquennial Census")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Chapter_9#h3i2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Historical Context")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Chapter_9#h3i3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Details are Included?")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Chapter_9#h3i4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding Aids")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Chapter_9#h3i5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Online Resources")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Chapter_9#h3i6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free Resources")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Chapter_9#h3i7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problems")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Chapter_9#h3i8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Use the Census Effectively")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Chapter_9#h3i9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taking it Further")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Chapter_9#h3i10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unique Features of the Non-English Censuses")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Chapter_9#h3i11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1tt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/016_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 10")])]), _vm._v(" 1911: The Fertility Census")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/016_Chapter_10#h3j1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Historical Context")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/016_Chapter_10#h3j2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Details are Included?")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/016_Chapter_10#h3j3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding Aids")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/016_Chapter_10#h3j4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Online Resources")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-8"
    }
  }), _c('h3', {
    staticClass: "toc1t"
  }, [_c('a', {
    attrs: {
      "id": "VPS-8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/016_Chapter_10#h3j5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free Resources")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/016_Chapter_10#h3j6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problems")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/016_Chapter_10#h3j7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Use the Census Effectively")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/016_Chapter_10#h3j8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taking it Further")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/016_Chapter_10#h3j9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unique Features of the Non-English Censuses")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/016_Chapter_10#h3j10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1tt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/017_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 11")])]), _vm._v(" Later Censuses")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/017_Chapter_11#h3k1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("History of the Census up to 1945")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/017_Chapter_11#h3k2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problems")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/017_Chapter_11#h3k3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What is Available Now?")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/017_Chapter_11#h3k4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What will be Available in the Future?")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1tt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/018_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 12")])]), _vm._v(" The Census Today")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/018_Chapter_12#h3l1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Census Recording Between 1945 and 2013")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/018_Chapter_12#h3l2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Post-War Censuses and Family History")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/018_Chapter_12#h3l3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Censuses of 2001 and 2011")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/018_Chapter_12#h3l4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Future Plans")])]), _vm._v(" "), _c('h2', {
    staticClass: "toctt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/020_Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix I: Census Records Online")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/021_Advert1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix II: Census Dates")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/022_Advert2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix III: Registrars-General")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/023_Advert3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix IV: Archives")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/024_Glossary",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix V: Glossary of Terms found in the Censuses")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/025_Abbr",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix VI: Abbreviations")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/026_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography and Further Reading")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/027_Endnotes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0